'use client';

import { Loader, ProgressBar } from 'components/atomic/atoms';
import { Footer, PageNotFound } from 'components/atomic/molecules';
import {
  HeaderMobileOrganism,
  HeaderWebOrganism,
  ToastContainerOrganism
} from 'components/atomic/organisms';
import { GetUiDeviceSurface } from 'lib/screenResolution';

const headerMap = {
  mobile: HeaderMobileOrganism,
  web: HeaderWebOrganism
};

const StandardLayout = ({
  children,
  loading,
  pageDataFound = true,
  pageNotFoundProps: {
    message = 'Oh Oh! Page Not Found',
    subMessage1 = 'The page you are looking for does not exist.',
    subMessage2 = 'Please check the URL and try again.'
  } = {},
  setShowToast,
  showCallIcon,
  showFooter = true,
  showHeader = true,
  showLoader = false,
  showToast = { show: false, status: false, message: '' },
  showWhatsapp = true
}) => {
  const surface = GetUiDeviceSurface();

  if (loading) {
    return <Loader />;
  }

  const direction = 'ltr';
  const Header = headerMap[surface];

  return (
    <>
      <ToastContainerOrganism {...{ showToast, setShowToast }} />
      {pageDataFound ? (
        <div
          className='flex flex-col justify-between h-screen'
          id='standard-layout-wrapper'
        >
          <div dir={direction}>
            {showLoader && <ProgressBar />}
            {showHeader && (
              <Header
                {...{
                  showWhatsapp,
                  showCallIcon
                }}
              />
            )}
            <main
              className='min-h-80 md:min-h-96'
              id='main-content'
            >
              {children}
            </main>
            {showFooter && <Footer />}
          </div>
        </div>
      ) : (
        <PageNotFound
          {...{
            message,
            subMessage1,
            subMessage2
          }}
        />
      )}
    </>
  );
};

export default StandardLayout;
